import { TabPanel, TabView } from 'primereact/tabview';
import '../../views/people.styles.css';
import FinanceTab from './finance/FinanceTab';
import InsightsTab from './insights/InsightsTab';
import OrderHistoryTab from './order-history/OrderHistoryTab';
import { TabHelper } from '@/common/TabHelper';
import { X4bEmployeeDetailsDto } from '@/types';

type Ride = {
	service?: string;
	average?: number;
	total?: string;
	time?: string;
};

type Send = {
	service?: string | null;
	average?: number | null;
	total?: string | null;
	time?: string | null;
};

type Eats = {
	product?: string | null;
	store?: string | null;
	total?: string | null;
	time?: string | null;
};

type Mart = {
	product?: string | null;
	store?: string | null;
	total?: string | null;
	day?: string | null;
};

type Insights = {
	lastLogin: string;
	lastCompletedBooking: string;
	customerTier: string;
	completedOrders: number;
	qrCode: string;
	ride: Ride;
	send: Send;
	eats: Eats;
	mart: Mart;
};

type Transaction = {
	id: string;
	date: string;
	time: string;
	type: string;
	status: 'Successful' | 'Failed';
	value: number;
};

type Order = {
	id: string;
	date: string;
	time: string;
	type: string;
	source: string;
	status: 'Completed' | 'Cancelled';
	value: number;
};

type OrderHistory = {
	orders: Order[];
};

type Finance = {
	transactions: Transaction[];
};

type Employee = {
	name: string;
	phone: string;
	email: string;
	employeeID: string;
	gender: string;
	loginMethod: string;
	city: string;
	inviteCode: string;
	role: string;
	group: string;
	program: string;
	createdAt: string;
	lastActive: string;
	insights: Insights;
	finance: Finance;
	orderHistory: OrderHistory;
};

type Props = {
	employee: X4bEmployeeDetailsDto;
};

const EmployeeActivities = (props: Props) => {
	const { employee } = props;
	return (
		<TabView
			pt={TabHelper.TabViewProps}
		>
			<TabPanel
				pt={TabHelper.TabPanelProps}
				header="Insights"
			>
				<InsightsTab employee={employee} />
			</TabPanel>
			<TabPanel
				pt={{
					headerAction: {
						className: 'peopleTabViewNavLink',
					},
					header: {
						className: 'peopleTabViewNavLi',
					},
				}}
				header="Finance"
			>
				<FinanceTab employee={employee} />
			</TabPanel>

			<TabPanel
				pt={{
					headerAction: {
						className: 'peopleTabViewNavLink',
					},
					header: {
						className: 'peopleTabViewNavLi',
					},
				}}
				header="Order History"
			>
				<OrderHistoryTab employee={employee} />
			</TabPanel>
		</TabView>
	);
};

export default EmployeeActivities;
